'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Aria class.
 */
var Aria = function () {
  _createClass(Aria, null, [{
    key: 'eventPolyfill',

    /**
     * Polyfill CustomEvent.
     *
     * @static
     * @returns {Boolean}
     */
    value: function eventPolyfill() {
      if ('function' === typeof window.CustomEvent) {
        return false;
      }

      function CustomEvent(event) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };

        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      CustomEvent.prototype = window.Event.prototype;

      window.CustomEvent = CustomEvent;
      return true;
    }

    /**
     * Create a CustomEvent.
     *
     * @static
     * @param {String} type The type of the event.
     * @param {Object} detail Data to be passed with the event.
     * @returns {Object}
     */

  }, {
    key: 'createAriaEvent',
    value: function createAriaEvent(type) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return new CustomEvent(type, {
        bubbles: true,
        cancelable: true,
        detail: detail
      });
    }

    /**
     * Check if an element is visible
     *
     * @static
     * @param {HTMLElement} element The element whose visibility is being checked
     * @returns {Boolean}
     */

  }, {
    key: 'isVisible',
    value: function isVisible(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    /**
     * Create an `id` attribute for the target element, based on a derpHash of the element's className.
     *
     * @returns {String}
     */

  }, {
    key: 'generateTargetId',
    value: function generateTargetId(element) {
      var targetClasses = element.className;
      // derpHash: Ensure a passably unique ID (but lets not go overboard)
      var derpHash = (Math.random() / targetClasses.length).toString(16).split('.')[1];
      return 'id_' + derpHash + '_' + targetClasses.split(' ').join('_');
    }
  }]);

  function Aria() {
    _classCallCheck(this, Aria);

    // eslint-disable-next-line max-len
    this.collectInteractiveChildren = this.collectInteractiveChildren.bind(this);
    this.setFocusToFirstItem = this.setFocusToFirstItem.bind(this);

    this.selectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'].join(',');

    this.tabKey = 9;
    this.escapeKey = 27;
  }

  /**
   * Collect all interactive child elements.
   */


  _createClass(Aria, [{
    key: 'collectInteractiveChildren',
    value: function collectInteractiveChildren() {
      var _this = this;

      if (undefined === this.targetElement) {
        // eslint-disable-next-line no-console
        console.error('No `targetElement` specified for collectInteractiveChildren');
        return;
      }

      var interactiveElements = this.targetElement.querySelectorAll(this.selectors);
      this.interactiveChildElements = Array.prototype.filter.call(interactiveElements, function (child) {
        return _this.constructor.isVisible(child);
      });
    }

    /**
     * Focus the dialog's first interactive child.
     */

  }, {
    key: 'setFocusToFirstItem',
    value: function setFocusToFirstItem() {
      if (this.interactiveChildElements.length) {
        this.interactiveChildElements[0].focus();
      }
    }
  }]);

  return Aria;
}();

exports.default = Aria;